// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BM-z","isFullWidth":"CM-z","landingPageVideo":"DM-z","play":"EM-z","iframeVideo":"FM-z","playHidden":"GM-z","fullwidth":"HM-z"};